<template>
  <div id="app">
    <img v-if="user.loggedin === true" class="logo" src="./assets/images/mango-icon.png">
    <ul class="nav" v-if="user.loggedin === true">
      <router-link tag="li" to="/clients">
        <a><span>Användare</span></a>
      </router-link>
      <router-link tag="li" to="/rooms">
        <a><span>Rum</span></a>
      </router-link>
      <router-link tag="li" to="/help">
        <a><span>Hjälp</span></a>
      </router-link>
      <li class="fixed-right"><a href="#" @click="logout()"><span>Logga ut</span></a></li>
    </ul>
    <!-- <Login @storeToken="storeToken" v-if="user.loggedin === false"></Login> -->

    <router-view></router-view>
    
  </div>
</template>

<script>
import Register from './components/Register.vue'
import Login from './components/Login.vue'
import Rooms from './components/Rooms.vue'
import Clients from './components/Clients.vue'
import Help from './components/Help.vue'

export default {
  name: 'app',
  components: {
    Register,
    Login,
    Clients,
    Rooms,
    Help
  },
  data: function(){
    return {
      api_url: process.env.VUE_APP_API_URL,
      app_url: process.env.VUE_APP_CLIENT_APP_URL,
      notification: '',
      user: {
        token: '',
        loggedin: false
      }
    }
  },
  methods:{
    storeToken(token){
      this.user.token = token;
      this.user.loggedin = true;
      console.log('Token set');
    },
    logout(){
      this.user.token = '';
      this.user.loggedin = false;
      this.$router.push('login');
    }
  }, 
  mounted: function(){
    if( this.user.loggedin === false ){
      this.$router.push('login');
    }
    
    let self = this;
    this.$root.$on('storeToken', function(token){
      self.user.token = token;
      self.user.loggedin = true;
      console.log('Token set');
    });
    
    // this.$root.$on('loadRooms', function(){
    //   console.log('CATCH!');
    // });
  }
}
</script>

<style lang="scss">
#app, #app input {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  box-sizing: border-box;
}

@import "./assets/css/_variables.scss";
@import "./assets/css/_mixins.scss";
@import "./assets/css/app.scss";
</style>
